import { Data, EnumHelper, List, NeoModel, NotifyUtils } from '@singularsystems/neo-core';
import { IEnumItem } from '@singularsystems/neo-core/dist/Model/EnumHelper';
import { Views } from '@singularsystems/neo-react';
import { NotificationDuration } from '../../../App/Models/Enums/NotificationDuration';
import { AppService, Types } from '../../../App/Services/AppService';
import { SQLTextValidationEnum } from '../../../Common/Models/SQLTextValidationEnum';
import StaticServiceProviderFileGroupingModel from '../../../Common/Models/StaticServiceProviderFileGroupingModel';
import { TextConstants } from '../../../Common/TextConstants';
import FileTypeLookup from '../../FileGroupingFileSpecs/Models/Lookups/FileTypeLookup';
import FileGroupingFileSpecView from '../../FileGroupingFileSpecs/Views/FileGroupingFileSpecView';
import ManageFileGroupingImportProcedureComponentVM from '../Components/ManageFileGroupingImportProcedureComponentVM';
import SaveFileGroupingImportProcedureCommand from '../Models/Commands/SaveFileGroupingImportProcedureCommand';
import FileGroupingFileSpecImportProcedureLookup from '../Models/Lookups/FileGroupingFileSpecImportProcedureLookup';
import FileGroupingFileSpecImportProcedureCriteria from '../Models/Queries/FileGroupingFileSpecImportProcedureCriteria';

@NeoModel
export default class FileGroupingFileSpecImportProceduresVM extends Views.ViewModelBase {
    constructor(
        public fileGroupingFileSpecImportProceduresApiClient =  AppService.get(Types.ApiClients.FileGroupingFileSpecImportProceduresApiClient),
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public fileGroupingFileSpecApiClient =  AppService.get(Types.ApiClients.FileGroupingFileSpecApiClient),
        public generalApiClient =  AppService.get(Types.ApiClients.GeneralApiClient),
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private navigation = AppService.get(Types.Neo.Routing.NavigationHelper),
        public authorisationService = AppService.get(Types.Neo.Security.AuthorisationService)) {
            super(taskRunner);
    };

    public fileSpecID: number | null = null;
    public fileGroupingID: number | null = null;
    public fileGroupingFileSpecID: number | null = null;
    public stockbrokerName: string = "";
    public commandIsValid : boolean = true;
    public displayManageFileGroupingImportProcedureComponent: boolean = false;
    public errorCount: number = 0;
    public sqlTextValiationEnumList: IEnumItem[] = []
    public fileSpecDropdownList = new List(FileTypeLookup);
    public fileGroupingList = new List(StaticServiceProviderFileGroupingModel);
    public manageFileGroupingImportProcedureComponentVM = new ManageFileGroupingImportProcedureComponentVM();
    public fileGroupingFileSpecImportProcedureCriteria = new FileGroupingFileSpecImportProcedureCriteria();
    public saveFileGroupingImportProcedureCommand = new SaveFileGroupingImportProcedureCommand();

    public pageManager = new Data.PageManager(this.fileGroupingFileSpecImportProcedureCriteria, FileGroupingFileSpecImportProcedureLookup,
        this.fileGroupingFileSpecImportProceduresApiClient.getFileGroupingFileSpecImportProcedures, {
        pageSize: 10,
        sortBy: "stockbrokerName",
        sortAscending: true,
        fetchInitial: false,
        initialTaskRunner: this.taskRunner,
    });

    public async initialise(
        fileGroupingFileSpecID?: number,
        fileGroupingID?: number,
        staticFileSpecID?: number,)
    {
        this.fileGroupingFileSpecID = Number(fileGroupingFileSpecID);
        this.fileGroupingID = Number(fileGroupingID);
        this.fileSpecID = Number(staticFileSpecID);

        this.fileGroupingFileSpecImportProcedureCriteria.meta.staticServiceProviderFileGroupingID.value = Number(this.fileGroupingID);
        this.fileGroupingFileSpecImportProcedureCriteria.meta.staticFileSpecID.value = Number(this.fileSpecID);
        await this.loadFileGroupings();
        await this.loadFileSpecs();
        await this.pageManager.refreshData();
        this.populateSQLTextValidationEnumList();
    }

    public manageFileSpecImportProcedure(item?: FileGroupingFileSpecImportProcedureLookup) {
        if (item !== undefined) {
            this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.mapFrom(item!);
        }
        this.taskRunner.run(async () => { await this.manageFileGroupingImportProcedureComponentVM.initialise()});
        this.displayManageFileGroupingImportProcedureComponent = true;
    }

    public async loadFileGroupings() {
        const response = await this.taskRunner.waitFor(this.generalApiClient.getStaticServiceProviderFileGroupingList());
        this.fileGroupingList.set(response.data);
        this.stockbrokerName = String(this.fileGroupingList.find(x => x.staticServiceProviderFileGroupingId === this.fileGroupingID)?.serviceProviderGroupingName);
        this.fileGroupingFileSpecImportProcedureCriteria.serviceProviderGroupingName = this.stockbrokerName;
    }

    public async loadFileSpecs() {
        const response = await this.taskRunner.waitFor(this.fileGroupingFileSpecApiClient.getFileSpecList(this.fileGroupingID!));
        this.fileSpecDropdownList.set(response.data);
        this.fileGroupingFileSpecImportProcedureCriteria.fileTypeConcatenated = this.fileSpecDropdownList.find(x => x.staticFileSpecID === this.fileSpecID)?.propertiesConcatenated!;
        this.setComponentProperties(Number(this.fileSpecID), Number(this.fileGroupingID),Number(this.fileGroupingFileSpecID));
    }

    public cancel() {
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure = new FileGroupingFileSpecImportProcedureLookup();
        this.displayManageFileGroupingImportProcedureComponent = false;
        this.manageFileGroupingImportProcedureComponentVM.disabled = true;
        this.setComponentProperties(Number(this.fileSpecID), Number(this.fileGroupingID), Number(this.fileGroupingFileSpecID));
    }

    public async clearSearch() {
    }

    public onBack() {
        this.navigation.navigateToView(FileGroupingFileSpecView, {broker: this.stockbrokerName, fileGroupingID: this.fileGroupingID, fileSpecID: this.fileSpecID});
    }

    public async saveFileGroupingFileSpec() {
        this.saveFileGroupingImportProcedureCommand.fileGroupingFileSpecImportProcedure.mapFrom(this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure);
        this.validateCommand(this.saveFileGroupingImportProcedureCommand.fileGroupingFileSpecImportProcedure);
        if (this.commandIsValid)
        {
            this.taskRunner.run(async () => {
                var response = await this.fileGroupingFileSpecImportProceduresApiClient.saveFileGroupingImportProcedure(this.saveFileGroupingImportProcedureCommand!.toJSObject());
                if (response.data.success) {
                    NotifyUtils.addSuccess(TextConstants.Titles.Success, TextConstants.Notifications.ImportConfigSuccessful, NotificationDuration.Standard);
                    this.displayManageFileGroupingImportProcedureComponent = false;
                    await this.pageManager.refreshData();
                }
                else {
                    NotifyUtils.add(TextConstants.Titles.Error, response.data.error, "danger" as any, NotificationDuration.Long);
                }
            });
        }
    }

    public async setFileSpecDropdown() {
        this.fileGroupingID = this.fileGroupingFileSpecImportProcedureCriteria.staticServiceProviderFileGroupingID;
        this.fileGroupingFileSpecImportProcedureCriteria.staticFileSpecID = null;
        await this.pageManager.refreshData();
        this.stockbrokerName = String(this.fileGroupingList.find(x => x.staticServiceProviderFileGroupingId === this.fileGroupingID)?.serviceProviderGroupingName);
        if (this.pageManager.totalRecords > 0) {
            await this.loadFileSpecs();
        }
        else {
            this.fileGroupingFileSpecImportProcedureCriteria.staticFileSpecID = null;
        }
    }

    public async onFileSpecChange()
    {
        this.fileSpecID = Number(this.fileGroupingFileSpecImportProcedureCriteria.staticFileSpecID);
        this.setComponentProperties(this.fileSpecID, Number(this.fileGroupingFileSpecImportProcedureCriteria.staticServiceProviderFileGroupingID), Number(this.fileGroupingFileSpecID));
        await this.pageManager.refreshData();
    }

    public setComponentProperties(fileSpecID: number, fileGroupingID: number, fileGroupingFileSpecID: number)
    {
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.staticFileSpecID = fileSpecID;
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.staticServiceProviderFileGroupingId = this.fileGroupingID;
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.staticServiceProviderFileGroupingFileSpecId = fileGroupingFileSpecID;
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.stockbrokerName = String(this.fileGroupingList.find(x => x.staticServiceProviderFileGroupingId === fileGroupingID)?.serviceProviderGroupingName);
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.fileType = String(this.fileSpecDropdownList.find(x => x.staticFileSpecID === fileSpecID)?.fileType);
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.activeStartDate = this.fileSpecDropdownList.find(x => x.staticFileSpecID === fileSpecID)?.activeStartDate ?? null;
        this.manageFileGroupingImportProcedureComponentVM.managedFileGroupingFileSpecImportProcedure.activeEndDate = this.fileSpecDropdownList.find(x => x.staticFileSpecID === fileSpecID)?.activeEndDate ?? null;
    }

    private validateCommand(command: FileGroupingFileSpecImportProcedureLookup) {
        if (command.filterClause !== null && command.filterClause !== '') {
            if (!(command.filterClause.toUpperCase().trim().startsWith("AND")) && !(command.filterClause.toUpperCase().trim().startsWith("OR"))) {
                this.commandIsValid = false;
                NotifyUtils.add(TextConstants.Titles.Error, TextConstants.Validation.InvalidFilterClause, "danger" as any, NotificationDuration.Long);
            }
            this.validateSQL(command.filterClause.toUpperCase());
        }

         if (command.joinClause !== null &&  command.joinClause !== '') {
            const validJoinPrefixes = [
                "INNER JOIN", "LEFT JOIN", "RIGHT JOIN", "FULL JOIN", "CROSS JOIN", "JOIN"
            ];
            const joinClause = command.joinClause.toUpperCase().trim();
            if (!validJoinPrefixes.some(prefix => joinClause.startsWith(prefix))) {
                this.commandIsValid = false;
                NotifyUtils.add(TextConstants.Titles.Error, TextConstants.Validation.InvalidJoinClause, "danger" as any, NotificationDuration.Long);
            }
            this.validateSQL(command.joinClause.toUpperCase());
        }

        if (this.errorCount > 0) {
            NotifyUtils.add(TextConstants.Titles.Error, TextConstants.Validation.InvalidSQL, "danger" as any, NotificationDuration.Long);
        }
    }

    private populateSQLTextValidationEnumList() {
        this.sqlTextValiationEnumList = EnumHelper.asList(SQLTextValidationEnum);
    }

    private validateSQL(sql: string) {
        for (var i = 0; i < this.sqlTextValiationEnumList.length; i++) {
            if (sql.includes(this.sqlTextValiationEnumList[i].name + " "))
            {
                this.commandIsValid = false;
                this.errorCount++;
            }
        }
    }
}